<template>
  <vue-date-picker :config="config"
                   :value="selected"
                   placeholder="Séléctionnez une période"
                   @on-change="handleChange"
                   @input="handleInput"/>
</template>

<script>
/* globals moment */

import filter from '../../mixins/filter';

export default {
  mixins: [filter],

  computed: {
    config() {
      return {
        mode: 'range',
      };
    },
  },
  data() {
    return {
      selected: null,
    };
  },

  methods: {
    setSelected() {
      const params = this.getParam();
      this.selected = params ? params.split(',').join(' au ') : null;
    },

    handleChange(dates) {
      if (dates.length) {
        this.updateUrlParam(
          dates.map(date => moment(date).format('YYYY-MM-DD')).join(','),
        ).broadcast();
      }
    },

    handleInput(value) {
      if (!value) {
        this.removeUrlParam().broadcast();
      }
    },
  },
};
</script>
